import '@babel/polyfill'
import 'url-polyfill';

import init from '../main';
import router from '@/router/auth';

init(router);
